/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React, { useMemo, type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiStack } from '@/lib/ui';
import TicketList from './TicketList';
import { TicketType } from '@/api/constant';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';
import { useGroupRegistrationQuery } from '@/registration/hook/useGroupRegistrationQuery';
import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';
import InfoBox from '@/registration/component/InfoBox';
import { useDisclosure } from '@chakra-ui/react';
import EmptyWarningModal from '../MainTickets/EmptyWarningModal';
import { useIsGroupEmptyRegisTypeInCart } from '@/registration/hook/useIsGroupEmptyRegisTypeInCart';
import BaseThemeButton from '@/base/ThemeButton';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';
// import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';

const MainTickets: FC = () => {
  const { eventId } = useRegisterRoute();
  const { data: eventSetting } = useEventSettingsQuery(eventId);
  const groupRegistrationQuery = useGroupRegistrationQuery(eventId);
  const { toNextStep, toPreviousStep, isReviewing } = useRegisterGroupSteps();

  const { isOpen, onClose, onOpen } = useDisclosure();
  const { isGroupEmptyMainTicketInCart } = useIsGroupEmptyRegisTypeInCart(eventId);

  const handleNextStep = () => {
    if (isGroupEmptyMainTicketInCart) {
      onOpen();
    } else {
      toNextStep();
    }
  };

  const registrationTypeLabel = useMemo(() => {
    return eventSetting?.pageMetadata?.mainTicket?.title || 'Registration type';
  }, [
    eventSetting?.pageMetadata?.mainTicket?.title,
  ]);

  return (
    <RegisterLayout header={<GroupHeader />}>
      <QueryContainer query={groupRegistrationQuery}>
        {(groupRegistration) => {
          return (
            <>
              <BaseTransitionSlideLeft>
                <UiStack flexGrow={1} spacing={8}>
                  <InfoBox
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    title={registrationTypeLabel}
                    description={eventSetting?.pageMetadata?.mainTicket?.description}
                  />
                  <TicketList key={groupRegistration?.attendeeCategoryId} ticketType={TicketType.Main} onEmpty={toNextStep} groupRegistration={groupRegistration} />
                </UiStack>
              </BaseTransitionSlideLeft>
              <UiStack height={96} />
              <LayoutFooter isGroup>
                <UiHStack justifyContent={'space-between'} flexGrow={1}>
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toPreviousStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  leftIcon={(*/}
                  {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  {isReviewing ? 'Back' : 'Prev'}*/}
                  {/*</UiButton>*/}
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={handleNextStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  rightIcon={(*/}
                  {/*    <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  {isReviewing ? 'Done' : 'Next'}*/}
                  {/*</UiButton>*/}

                  <BaseThemeButton
                    theme={'gray'}
                    onClick={toPreviousStep}
                    leftIcon={(
                      <UiIconCaretLeft color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    {isReviewing ? 'Back' : 'Prev'}
                  </BaseThemeButton>
                  <BrandFooter/>
                  <BaseThemeButton
                    theme={'primary'}
                    onClick={handleNextStep}
                    rightIcon={(
                      <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    {isReviewing ? 'Done' : 'Next'}
                  </BaseThemeButton>
                </UiHStack>
              </LayoutFooter>
            </>
          );
        }}
      </QueryContainer>
      <EmptyWarningModal
        isOpen={isOpen}
        onClose={onClose}
        message={`You need to add a ${registrationTypeLabel.toLowerCase()} for every attendee to continue.`}
      />
    </RegisterLayout>
  );
};
export default MainTickets;
